import {
  TbColumnInsertLeft,
  TbColumnInsertRight,
  TbColumns1,
  TbLayoutRows,
  TbRowInsertBottom,
  TbRowInsertTop,
} from 'react-icons/tb';
import { Area, GridEntity, IRange } from '../../types';
import { BiHide, BiShow } from 'react-icons/bi';
import { IoMdResize } from 'react-icons/io';
import { RiDeleteBinLine } from 'react-icons/ri';
import { VscGroupByRefType, VscLayoutSidebarLeft } from 'react-icons/vsc';
import { ReturnTypeofSheetSectionsSelector } from '../../selectors/sheetUiSelector';
import { IContextMenuItem } from './types';
import { t } from 'i18next';
import { UseGridOperations } from '../../hooks/useGridOperations';
import { indexToColumnLetter } from '../../utils/area/area';
import { isRangeInsideRange } from '../../utils/area/range';
import { SheetCommandType } from '../../types/commands/sheetCommands/sheetCommands';
import { AppDispatch } from '../../../core/redux/store';
import { handleSheetOperations } from '../../redux/sagas/root/rootActions';
import { GridContextMenuProps } from './prepareContextMenu';

interface GetCommonEntityMenu {
  entityName: GridEntity;
  props: GridContextMenuProps; // ReturnTypeofSheetSectionsSelector;
  // freeze: Freeze;
  area: Area;
  parentLangKey: string;
  dispatch: AppDispatch;
}

// #region get lang keys
const getLangKeys = (
  count: number,
  freezeCount: number,
  hiddenRangesCount: number
) => [
  'insert',
  count > 1 ? `delete_other` : `delete_one`,
  count > 1 ? `hide_other` : `hide_one`,
  count > 1 ? `resize_other` : `resize_one`,
  count > 1 ? `group_other` : `group_one`,
  'freeze',
  freezeCount == 0 ? undefined : getUnFreezeKey(freezeCount),
  hiddenRangesCount > 0 ? 'unhide' : undefined,
];

export const insertEntityLangKeys = (entityName: GridEntity) => [
  entityName === GridEntity.Column ? 'insert_left' : 'insert_above',
  entityName === GridEntity.Column ? 'insert_right' : 'insert_below',
];

const getUnFreezeKey = (count: number) =>
  count > 1 ? 'unfreeze_other' : 'unfreeze_one';
// #endregion

export const getCommonEntityMenu = ({
  area,
  entityName,
  // freeze,
  props,
  parentLangKey,

  dispatch,
}: GetCommonEntityMenu) => {
  const isCol = entityName === GridEntity.Column;
  const freeze = isCol ? props.freezedCols : props.freezedRows;
  const hiddenRanges = isCol ? props.hiddenCols : props.hiddenRows;
  const alias = isCol ? 'ci' : 'ri';

  const count = area.end[alias] - area.start[alias] + 1;
  const range = {
    start: area.start[alias],
    end: area.end[alias],
  };

  // const hiddenRanges = isRangeInsideRanges

  const areaHiddenRanges: IRange[] = [];
  for (let hiddenRange of hiddenRanges) {
    if (isRangeInsideRange(range, hiddenRange))
      areaHiddenRanges.push(hiddenRange);
  }

  const start = isCol ? indexToColumnLetter(area.start.ci) : area.start.ri + 1; // indexToColumnLetter(area.start.ri);
  const end = isCol ? indexToColumnLetter(area.end.ci) : area.end.ri + 1;

  const langParams = {
    count,
    start,
    end,
    entityName,
  };

  const freezeCount = freeze.frozen ? freeze.end - freeze.start + 1 : 0;
  const menus: IContextMenuItem[] = [];
  getLangKeys(count, freezeCount, areaHiddenRanges.length).forEach(
    (langKey) => {
      if (langKey) {
        const title = t(`${parentLangKey}.${langKey}`, langParams);
        let nestedMenus: IContextMenuItem[][] | undefined;
        if (langKey === 'insert') {
          // Generate nested
          const nMenus: IContextMenuItem[] = insertEntityLangKeys(
            entityName
          ).map((insertLangKey) => {
            const InsertIcon = getEntityMenuIcon(entityName, insertLangKey);

            return {
              title: t(`${parentLangKey}.${insertLangKey}`, langParams),
              Icon: InsertIcon,
              action: getEntityMenuAction(
                props.sheetId,
                entityName,
                insertLangKey,
                range,
                areaHiddenRanges,
                // performCellOperation
                dispatch
              ),
            };
          });
          nestedMenus = [nMenus];
        }
        const Icon = getEntityMenuIcon(entityName, langKey);

        menus.push({
          title,
          Icon,
          nestedMenus,
          action: getEntityMenuAction(
            props.sheetId,
            entityName,
            langKey,
            range,
            areaHiddenRanges,
            // performCellOperation,
            dispatch
          ),
        });
      }
    }
  );

  return menus;
};

const getEntityMenuIcon = (entityName: GridEntity, langKey: string) => {
  const isCol = entityName === GridEntity.Column;
  switch (true) {
    case langKey === 'insert':
      return isCol ? TbColumnInsertRight : TbRowInsertBottom;

    case langKey === 'insert_left':
      return TbColumnInsertLeft;

    case langKey === 'insert_right':
      return TbColumnInsertRight;

    case langKey === 'insert_above':
      return TbRowInsertTop;

    case langKey === 'insert_below':
      return TbRowInsertBottom;

    case langKey.includes('delete'):
      return RiDeleteBinLine;

    case langKey.includes('unhide'):
      return BiShow;

    case langKey.includes('hide'):
      return BiHide;

    case langKey.includes('resize'):
      return IoMdResize;

    case langKey.includes('group'):
      return VscGroupByRefType;

    case langKey.includes('unfreeze'):
      return TbColumns1;

    case langKey.includes('freeze'):
      return isCol ? VscLayoutSidebarLeft : TbLayoutRows;
  }
};

const getEntityMenuAction = (
  sheetId: string,
  entity: GridEntity,
  langKey: string,
  range: IRange,
  hiddenRanges: IRange[],
  // performGridOperation: UseGridOperations['performGridOperation'],
  // performCellOperation: UseGridOperations['performCellOperation'],
  dispatch: AppDispatch
) => {
  switch (true) {
    // case langKey === 'insert':
    //   return undefined

    case langKey === 'insert_left':
    case langKey === 'insert_above':
    case langKey.includes('delete'): {
      return () => {};
      // performCellOperation({
      //   op: langKey.includes('delete')
      //     ? CellOperations.Delete
      //     : CellOperations.Insert,
      //   entity,
      //   range, // In case of delete it will be the source and in case of insert it will be destination
      // });
    }

    case langKey === 'insert_below':
    case langKey === 'insert_right': {
      const count = range.end - range.start;
      const start = range.end + 1;
      const end = start + count;
      return () => {};
      // performCellOperation({
      //   op: CellOperations.Insert,
      //   entity,
      //   range: {
      //     start: start,
      //     end: end,
      //   },
      // });
    }

    case langKey.includes('unhide'):
      return () =>
        dispatch(
          handleSheetOperations({
            type: SheetCommandType.UnhideGrid,
            ranges: hiddenRanges,
            entity: entity,
            sheetId,
          })
        );
    // performGridOperation(entity, {
    //   op: SheetCommandType.UnhideGrid,
    //   ranges: hiddenRanges,
    // });

    case langKey.includes('hide'):
      return () =>
        dispatch(
          handleSheetOperations({
            type: SheetCommandType.HideGrid,
            ranges: [range],
            entity,
            sheetId,
          })
        );

    // performGridOperation(entity, {
    //   op: SheetCommandType.HideGrid,
    //   ranges: [range],
    // });

    // case langKey.includes('resize'):
    //   return IoMdResize;

    case langKey.includes('group'):
      return () => {};
    // performGridOperation(entity, {
    //   op: SheetCommandType.GroupGrid,
    //   ranges: [range],
    // });

    case langKey.includes('unfreeze'):
      return () =>
        dispatch(
          handleSheetOperations({
            type: SheetCommandType.FreezeGrid,
            range: { start: -1, end: -1 },
            sheetId,
            entity,
          })
        );
    // performGridOperation(entity, {
    //   op: SheetCommandType.FreezeGrid,
    //   range: { start: -1, end: -1 },
    // });

    case langKey.includes('freeze'):
      return () =>
        dispatch(
          handleSheetOperations({
            type: SheetCommandType.FreezeGrid,
            range: { ...range, start: 0 },
            sheetId,
            entity,
          })
        );
    // performGridOperation(entityType, {
    //   op: SheetCommandType.FreezeGrid,
    //   range: {
    //     ...range,
    //     start: 0,
    //   },
    // });
  }
  return undefined;
};

/*
    === Row Menu Actions ===
    Insert >
            ${count} before
            ${count} after
    Delete Row/s ${Range}
    Clear Row/s ${Range}
    Hide Row/s ${Range}
    Resize Row/s ${Range}
    Freeze up to row ${startIndex}
    Group Row/s ${range}

    => Archive Row 
    => Move Rows to Trash
*/
